var _rect, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFhir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 60",
    role: "img",
    "aria-label": "FHIR R4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 198,
    height: 58,
    rx: 10,
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 18 L24 42 M24 30 L34 30 M34 18 L34 42",
    stroke: "#b33a1d",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 38,
    textAnchor: "middle",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#b33a1d",
    letterSpacing: 2
  }, "FHIR R4")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFhir);
export default __webpack_public_path__ + "static/media/fhir.d6e4a6fbaa0bd6d3a6e98818adefa6b6.svg";
export { ForwardRef as ReactComponent };